import { RuleSearchDetailPage } from "./RuleSearchDetailPage";
export default RuleSearchDetailPage;
